// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2Gq7u","noInteraction":"EventWrapper_noInteraction__14EL5","pointerPassthrough":"EventWrapper_pointerPassthrough__2C_MF"};